import { RESET_ALL_STATES } from '../actions/actions';


import {
    GET_UPDATE_REQUEST ,
    GET_UPDATE_SUCCESS, 
    GET_UPDATE_FAILURE, 
  } from '../actions/actionTypes';
  

const initialState = {
  isLoading: false,
  error: null,
  data: null, 
};

const getUpdateRequest = (state = initialState, action) => {
  switch (action.type) {
    case GET_UPDATE_REQUEST:
      return { ...state, isLoading: true, error: null };
    case GET_UPDATE_SUCCESS:
      return { ...state, isLoading: false, data: action.payload };
    case GET_UPDATE_FAILURE:
      return { ...state, isLoading: false, error: action.payload };
      case RESET_ALL_STATES:
        return initialState;
      default:
      return state;
  }
};

export default getUpdateRequest;

  